import { useEffect, useMemo, useState } from "react";
import api from "../api";
import { AppCard, MysteryCard } from "../components/AppCard";
import { MaskedLines, Reveal } from "../components/Reveal";
import { Marquee } from "../components/Marquee";

export default function Apps() {
  const [apps, setApps] = useState([]);
  const [loading, setLoading] = useState(true);
  const [filter, setFilter] = useState("All");

  useEffect(() => {
    api
      .get("/apps")
      .then((r) => setApps(r.data))
      .catch(() => {})
      .finally(() => setLoading(false));
  }, []);

  const filters = useMemo(
    () => ["All", ...new Set(apps.map((a) => a.age_range).filter(Boolean))],
    [apps]
  );
  const visible = filter === "All" ? apps : apps.filter((a) => a.age_range === filter);

  return (
    <main>
      <section className="px-4 sm:px-8 pt-14 sm:pt-20 pb-14">
        <div className="max-w-7xl mx-auto">
          <span className="text-xs font-extrabold uppercase tracking-[0.2em] text-coral">
            Apps & Games
          </span>
          <h1 className="mt-2 font-display font-black text-4xl sm:text-5xl lg:text-6xl tracking-tight">
            <MaskedLines lines={["Every game,", "a new adventure"]} />
          </h1>
          <Reveal delay={0.3}>
            <p className="mt-5 text-base sm:text-lg text-ink/70 max-w-2xl leading-relaxed">
              All our learning games in one place. Pick an age range, find a world to
              explore — our apps are launching soon on the App Store and Google Play.
            </p>
          </Reveal>

          <Reveal delay={0.4} className="mt-8 flex flex-wrap gap-2.5">
            {filters.map((f) => (
              <button
                key={f}
                data-testid={`app-filter-tab-${f.toLowerCase().replace(/\s+/g, "-")}`}
                onClick={() => setFilter(f)}
                className={`px-5 py-2.5 rounded-full font-bold text-sm border-2 border-ink transition-all duration-200 ${
                  filter === f
                    ? "bg-ink text-cream shadow-brutal-sm"
                    : "bg-white text-ink/70 hover:-translate-y-0.5 hover:shadow-brutal-sm"
                }`}
              >
                {f}
              </button>
            ))}
          </Reveal>
        </div>
      </section>

      <section className="px-4 sm:px-8 pb-24">
        <div className="max-w-7xl mx-auto">
          {loading ? (
            <div data-testid="apps-loading" className="py-20 text-center font-display font-bold text-xl text-ink/50">
              Loading games…
            </div>
          ) : visible.length === 0 ? (
            <div
              data-testid="apps-empty-state"
              className="rounded-3xl border-2 border-dashed border-ink/30 bg-white/60 p-14 text-center"
            >
              <p className="font-display font-bold text-2xl">No games here yet</p>
              <p className="mt-2 text-ink/60">New adventures are being built right now. Check back soon!</p>
            </div>
          ) : (
            <div data-testid="apps-grid" className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
              {visible.map((app, i) => (
                <Reveal key={app.id} delay={i * 0.08}>
                  <AppCard app={app} />
                </Reveal>
              ))}
              <Reveal delay={visible.length * 0.08}>
                <MysteryCard />
              </Reveal>
            </div>
          )}
        </div>
      </section>

      <Marquee />
    </main>
  );
}
